// extracted by mini-css-extract-plugin
export default {"informationView":"Privacy_informationView__NhwXh"};